import SectionDivider from '@components/profile/teacher/section-divider'
import { useProfileContext } from '@contexts/profile'
import React from 'react'

const TeacherVideo = () => {
  const { profileDetails } = useProfileContext()
  const videoUrl = profileDetails?.teacher?.videoUrl
  const poster = profileDetails?.teacher?.videoThumbnail

  if (!videoUrl) return null

  return (
    <>
      <SectionDivider />
      <section className="p-5 lg:p-10">
        <h2 className="inline-block bg-orange text-white font-600 rounded px-3 py-1 mb-4">
          Meet your teacher
        </h2>
        <video
          className="w-full rounded-lg"
          controls
          preload="metadata"
          src={videoUrl}
          poster={poster || undefined}
        >
          Your browser does not support the video tag.
        </video>
      </section>
    </>
  )
}

export default React.memo(TeacherVideo)
